// The one-time link from `admin:staff enrol`: confirm the app account's
// email and password, then create the admin passkey and sign in.
import { useState, type FormEvent } from "react";
import { useNavigate, useParams } from "react-router";
import { session } from "../api";
import { enrol, enrolmentOptions, passkeysSupported } from "../auth/passkeys";
import { errorText } from "../problem";

type Step = "form" | "checking" | "passkey";

export function EnrolPage() {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState<Step>("form");
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setStep("checking");
    try {
      const options = await enrolmentOptions({ token, email: email.trim(), password });
      setStep("passkey");
      await session.signIn(await enrol(options));
      void navigate("/", { replace: true });
    } catch (e) {
      setError(errorText(e));
      setStep("form");
    }
  }

  return (
    <main className="card-page">
      <form className="card" onSubmit={(event) => void submit(event)}>
        <h1>Set up your admin passkey</h1>
        <p>
          Confirm the email and password of your ten20 account. Then your browser creates a passkey for this console
          only.
        </p>
        {!passkeysSupported() && <p className="error">This browser doesn't support passkeys.</p>}
        <label>
          Email
          <input
            type="email"
            autoComplete="username"
            required
            maxLength={254}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            required
            maxLength={256}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        <button type="submit" disabled={step !== "form" || token === ""}>
          {step === "checking" ? "Checking…" : step === "passkey" ? "Waiting for your passkey…" : "Continue"}
        </button>
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
        <p className="muted">The link works once, for 15 minutes.</p>
      </form>
    </main>
  );
}
